import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ArtifactAssociationModel } from 'src/app/Models/artifact-association-model';
import { ArtifactConnectionModel } from 'src/app/Models/artifact-connection-model';
import { ArtifactModel } from 'src/app/Models/artifact-model';
import { CodeLinkageMappingModel } from 'src/app/Models/code-linkage-mapping-model';
import { CodeLinkageService } from 'src/app/Services/code-linkage.service';
import { OrganisationService } from 'src/app/Services/organisation.service';
import { ProjectService } from 'src/app/Services/project.service';
import { SharedService } from 'src/app/Services/shared.service';
import { ArtifactTypeEnum } from 'src/app/shared/enums/common.enum';
import { NotifyService } from 'src/app/Services/notify.service';
import { log } from 'util';

import * as XLSX from 'xlsx';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { CodeReviewService } from 'src/app/Services/code-review.service';
import { AddCodeReviewComponent } from 'src/app/AppBaseComponents/code-review-component/add-code-review/add-code-review.component';
import { GithubIntegrationService } from 'src/app/Services/github-integration.service';

@Component({
  selector: 'ze-code-linkage-view',
  templateUrl: './code-linkage-view.component.html',
  styleUrls: ['./code-linkage-view.component.scss']
})
export class CodeLinkageViewComponent implements OnInit, AfterViewInit  {

  isArtifactAssociationLoading: boolean = true;
  isCodeReviewCheckLoading: boolean = true;
  isActiveCodeLinkageAvailable: boolean = false;
  isActiveCodeReviewAvailable: boolean = false;
  codeReviewId: string = null;
  isFieldsLoading: boolean = true;
  isDataLoading: boolean = true;
  isArtifactLoading: boolean = true;
  codeLinkageFieldsNamesList: string[] = [];
  pmFieldNamesList: string[] = [];
  tdFieldNamesList: string[] = [];
  codeLinkedDataList: string[][] = [];
  artifactConnectionModel: ArtifactConnectionModel = new ArtifactConnectionModel();
  artifactAssociationsList: ArtifactAssociationModel[] = [];
  userName: string;
  currentCommitPage: number = 1;
  isMoreCommitsAvailable: boolean = true;

  projectId: string;
  artifactName: string;
  artifactId: string;
  artifactType: string;
  isValidArtifact: boolean = true;
  codeLinkageId: string;
  codeLinkageMappingModel: CodeLinkageMappingModel = new CodeLinkageMappingModel();

  isAccordionOneOpen: boolean = true;
  isAccordionTwoOpen: boolean = true;
  isAddingNewRow: boolean = false;

  newRowForm: FormGroup;
  githubCommitForm: FormGroup;
  selectedProjectManagementFile: File | null = null;


  // Dropdown options for new row
  suiteOptions: ArtifactModel[] = [];
  featureOptions: ArtifactModel[] = [];
  scenarioOptions: ArtifactModel[] = [];
  stepOptions: ArtifactModel[] = [];

  githubRepoOptions: string[] = [];
  githubRepoCommitOptions: any[] = [];  
  githubRepoBranchOptions: string[] = [];
  isGithubIntegrated: boolean = false;
  isAddingGithubCommit: boolean = false;
  emptyDropDownOption: any = "";

  constructor(
    private organisationService: OrganisationService,
    private codeLinkageService: CodeLinkageService,
    private codeReviewService: CodeReviewService,
    private projectService: ProjectService,    
    private githubIntegrationService: GithubIntegrationService,
    private router: Router,
    private sharedService: SharedService,
    private formBuilder: FormBuilder,
    private notifys: NotifyService,
    public dialogRef: MatDialogRef<CodeLinkageViewComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
    this.newRowForm = this.formBuilder.group({
      suite: [null, Validators.required],
      feature: [null, Validators.required],
      scenario: [null, Validators.required],
      step: [null, Validators.required]
    });

    this.githubCommitForm = this.formBuilder.group({
      repo: [null, Validators.required],
      branch: [null, Validators.required],
      commit: [null, Validators.required]
    });
    this.sharedService.loaderHide.emit(true);
    this.artifactId = this.data['artifactId'];
    this.artifactType = this.data['artifactType'];
    this.projectId = localStorage.getItem("projectId");

    this.githubIntegrationService.isGithubIntegrated().subscribe(data => {
      if (data["data"] == null || data["operationStatus"] == "ERROR") {
        this.isGithubIntegrated = false;
      } else {
        this.isGithubIntegrated = data["data"];
      }
    }, error => {
    });

    if (this.artifactType === "suite" || this.artifactType === "feature" || this.artifactType === "scenario" || this.artifactType === "step") {
      this.projectService.getArtifactFromProject(this.projectId, this.artifactId, this.artifactType)
      .subscribe(data => {
        if (data['data'] == null) {
          this.isArtifactLoading = false;
          this.isValidArtifact = false;
          if (data["operationStatus"] == "ERROR") {
            // alert("Error in Fetching Artifact");
          }
        } else {
          this.artifactName = data['data'].name;
          this.isArtifactLoading = false;
          this.isValidArtifact = true;
          let currentUser = JSON.parse(localStorage.getItem("currentUser")).token;
          this.userName = this.parseJwt(JSON.stringify(currentUser)).sub;
          this.codeLinkageService.isCodeLinkageExistByArtifactId(this.artifactType, this.artifactId).subscribe(data => {
            if (data["data"] == null || data["operationStatus"] == "ERROR") {
              this.isArtifactAssociationLoading = false;
              this.isFieldsLoading = false;
              this.isCodeReviewCheckLoading = false;
              alert("Error in checking codelinkage exists..");
            } else {
              this.isActiveCodeLinkageAvailable = data['data'] == null ? false : data['data'];
              if(this.isActiveCodeLinkageAvailable) {
                this.checkCodeReviewExists();
              } else {
                this.isActiveCodeReviewAvailable = false;
                this.isCodeReviewCheckLoading = false;
              }
              this.getArtifactAssociationMappings();
              this.getCodeLinkageFields();
            }
          }, error => {
          });
        }
        this.sharedService.loaderHide.emit(false);
      }, error => {
        this.isArtifactLoading = false;
        this.isValidArtifact = false;
        this.sharedService.loaderHide.emit(false);
      });
    } else {
      this.isArtifactLoading = false;
      this.isValidArtifact = false;
      this.sharedService.loaderHide.emit(false);
    }
    this.newRowForm = this.formBuilder.group({
      suite: [null, Validators.required],
      feature: [null, Validators.required],
      scenario: [null, Validators.required],
      step: [null, Validators.required]
    });
  }

  onProjectManagementFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input && input.files && input.files.length > 0) {
        this.selectedProjectManagementFile = input.files[0];
    }
  }

  checkCodeReviewExists() {
    this.codeReviewService.getCodeReviewIdByArtifactId(this.artifactId).subscribe(data => {
      if (data["data"] == null || data["operationStatus"] == "ERROR") {
        this.isActiveCodeReviewAvailable = false;
      } else {
        this.isActiveCodeReviewAvailable = true;
        this.codeReviewId = data["data"];
      }
      this.isCodeReviewCheckLoading = false;
    }, error => {
      this.isCodeReviewCheckLoading = false;
    });
  }

  openCodeReview() {
    this.router.navigate(['/code-link-review/' + this.codeReviewId]);
    this.dialogRef.close();
  }

  createCodeReview() {
    // this.dialogRef.close();
    const codeReviewDialogRef = this.dialog.open(AddCodeReviewComponent, {
      width: '70%',
      height: '70%',
      disableClose: true,
      data: {
        projectId: this.projectId,
        artifact: {
          artifactId: this.artifactId,
          artifactName: this.artifactName,
          artifactType: this.artifactType
        }
      },
      backdropClass: 'overlay-backdrop-dark-class',
    });

    codeReviewDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.codeReviewId = result;
        this.openCodeReview();
      }
    });
  }
  
  close() {
    this.dialogRef.close();
  }

  //@Jishnu
  toggleAccordionOne() {
    this.isAccordionOneOpen = !this.isAccordionOneOpen;
  }
  toggleAccordionTwo() {
    this.isAccordionTwoOpen = !this.isAccordionTwoOpen;
  }

  addNewRow() {
    this.isAddingNewRow = true;
    this.prefillForm();
    this.populateDropdownOptions();
  }

  addGithubCommit() {
    this.sharedService.loaderHide.emit(true);
    this.isAddingGithubCommit = true;
    this.githubRepoOptions = [];
    this.githubRepoCommitOptions = [];
    this.githubRepoBranchOptions = [];
    this.githubIntegrationService.getGithubReposByUser().subscribe(data => {
      if (this.handleGithubReauth(data)) {
        return;
      }
      if (data["data"] == null && data["operationStatus"] == "ERROR") {
        this.githubCommitForm.get("repo").setValue(null);
        this.githubCommitForm.get("branch").setValue(null);
        this.githubCommitForm.get("commit").setValue(null);
        this.sharedService.loaderHide.emit(false);
        this.notifys.notify('error', 'Failed', "Error in fetching Github Repos");
      } else {
        this.githubRepoOptions = data["data"];
        if (this.githubRepoOptions.length > 0) {
          this.githubCommitForm.get("repo").setValue(this.githubRepoOptions[0]);
          this.getBranchesBySelectedRepo(this.githubRepoOptions[0], "1");
        } else {
          this.githubCommitForm.get("repo").setValue(this.emptyDropDownOption);
          this.githubCommitForm.get("branch").setValue(this.emptyDropDownOption);
          this.githubCommitForm.get("commit").setValue(this.emptyDropDownOption);
        }
        this.sharedService.loaderHide.emit(false);
      }
    }, error => {
      this.sharedService.loaderHide.emit(false);
    });
  }

  /** Both GitHub tokens expired: send the user to the GitHub integration page to authenticate again. */
  private handleGithubReauth(data: any): boolean {
    if (!this.githubIntegrationService.isReauthRequired(data)) {
      return false;
    }
    this.sharedService.loaderHide.emit(false);
    this.notifys.notify('error', 'GitHub session expired', "Please authenticate GitHub again");
    this.dialogRef.close();
    this.router.navigate(['/github'], { queryParams: { returnUrl: this.router.url } });
    return true;
  }

  loadMoreCommits(repo: string, branch: string) {
    if (this.isMoreCommitsAvailable) {
      this.sharedService.loaderHide.emit(true);
      const nextPage = this.currentCommitPage + 1;
      this.getCommitsBySelectedRepoBranch(repo, branch, nextPage+"");
    }
  }

  getBranchesBySelectedRepo(repo: string, pageNumber: string) {
    this.githubIntegrationService.getGithubRepoBranchesByRepo(repo, pageNumber).subscribe(data => {
      if (this.handleGithubReauth(data)) {
        return;
      }
      if (data["data"] == null && data["operationStatus"] == "ERROR") {
        this.githubCommitForm.get("branch").setValue(null);
        this.githubCommitForm.get("commit").setValue(null);
        this.sharedService.loaderHide.emit(false);
        this.notifys.notify('error', 'Failed', "Error in fetching Github Branches");
      } else {
        this.githubRepoBranchOptions = data["data"];
        if (this.githubRepoBranchOptions.length > 0) {
          this.isMoreCommitsAvailable = true;
          this.githubCommitForm.get("branch").setValue(this.githubRepoBranchOptions[0]);
          this.getCommitsBySelectedRepoBranch(repo, this.githubRepoBranchOptions[0], pageNumber);
        } else {
          this.githubCommitForm.get("branch").setValue(this.emptyDropDownOption);
          this.githubCommitForm.get("commit").setValue(this.emptyDropDownOption);
        }
        this.sharedService.loaderHide.emit(false);
      }
    }, error => {
      this.sharedService.loaderHide.emit(false);
    });
  }

  getCommitsBySelectedRepoBranch(repo: string, branch: string, pageNumber: string) {
    this.githubIntegrationService.getGithubRepoCommitsByRepoBranch(repo, branch, pageNumber).subscribe(data => {
      if (this.handleGithubReauth(data)) {
        return;
      }
      if (data["data"] == null && data["operationStatus"] == "ERROR") {
        this.githubCommitForm.get("commit").setValue(null);
        this.sharedService.loaderHide.emit(false);
        this.notifys.notify('error', 'Failed', "Error in fetching Github Repos");
      } else {
        this.githubRepoCommitOptions = this.githubRepoCommitOptions.concat(data["data"]);
        if (this.githubRepoCommitOptions.length > 0) {
          this.githubCommitForm.get("commit").setValue(this.githubRepoCommitOptions[0]);
          this.currentCommitPage = Number(pageNumber);
        } else {
          this.githubCommitForm.get("commit").setValue(this.emptyDropDownOption);
          this.isMoreCommitsAvailable = false;
        }
        this.sharedService.loaderHide.emit(false);
      }
    }, error => {
      this.sharedService.loaderHide.emit(false);
    });
  }

  onRepoChange(repo) {
    this.githubRepoCommitOptions = [];
    this.githubRepoBranchOptions = [];
    this.sharedService.loaderHide.emit(true);
    this.getBranchesBySelectedRepo(repo, "1");
  }

  onBranchChange(repo, branch) {
    this.githubRepoCommitOptions = [];
    this.sharedService.loaderHide.emit(true);
    this.isMoreCommitsAvailable = true;
    this.getCommitsBySelectedRepoBranch(repo, branch, "1");
  }

  isGithubCommitFormInValid() {
    return this.selectedProjectManagementFile == null || this.githubCommitForm.controls.repo.value == this.emptyDropDownOption || this.githubCommitForm.controls.branch.value == this.emptyDropDownOption || this.githubCommitForm.controls.commit.value == this.emptyDropDownOption || !this.githubCommitForm.valid;
  }

  prefillForm() {
    switch (this.artifactConnectionModel.artifactType) {
      case ArtifactTypeEnum.Suite:
        this.newRowForm.get(ArtifactTypeEnum.Suite).setValue(Object.values(this.artifactConnectionModel.suites)[0]);
        this.newRowForm.get(ArtifactTypeEnum.Suite).disable();
        break;
      case ArtifactTypeEnum.Feature:
        this.newRowForm.get(ArtifactTypeEnum.Feature).setValue(Object.values(this.artifactConnectionModel.features)[0]);
        this.newRowForm.get(ArtifactTypeEnum.Feature).disable();
        break;
      case ArtifactTypeEnum.Scenario:
        this.newRowForm.get(ArtifactTypeEnum.Scenario).setValue(Object.values(this.artifactConnectionModel.scenarios)[0]);
        this.newRowForm.get(ArtifactTypeEnum.Scenario).disable();
        break;
      case ArtifactTypeEnum.Step:
        this.newRowForm.get(ArtifactTypeEnum.Step).setValue(Object.values(this.artifactConnectionModel.steps)[0]);
        this.newRowForm.get(ArtifactTypeEnum.Step).disable();
        break;
    }
  }

  populateDropdownOptions() {
    this.updateSuiteDropdownOptions();
    this.updateFeatureDropdownOptions();
    this.updateScenarioDropdownOptions();
    this.updateStepDropdownOptions();
  }

  updateSuiteDropdownOptions() {
    if (this.artifactConnectionModel.artifactType !== ArtifactTypeEnum.Suite) {
      if(this.newRowForm.controls.feature.value != null) {
        const selectedFeatureId = this.newRowForm.controls.feature.value.id;
        this.suiteOptions = Object.values(this.artifactConnectionModel.suites).filter(suite => suite.features.includes(selectedFeatureId));
      } else if (this.newRowForm.controls.scenario.value != null) {
        const selectedScenarioId = this.newRowForm.controls.scenario.value.id;
        this.suiteOptions = Object.values(this.artifactConnectionModel.suites).filter(suite => suite.scenarios.includes(selectedScenarioId));
      } else if (this.newRowForm.controls.step.value != null) {
        const selectedStepId = this.newRowForm.controls.step.value.id;
        this.suiteOptions = Object.values(this.artifactConnectionModel.suites).filter(suite => suite.steps.includes(selectedStepId));
      }
    } else {
      this.suiteOptions = Object.values(this.artifactConnectionModel.suites)
    }
  }

  updateFeatureDropdownOptions() {
    if (this.artifactConnectionModel.artifactType !== ArtifactTypeEnum.Feature) {
      if (this.newRowForm.controls.scenario.value != null) {
        const selectedScenarioId = this.newRowForm.controls.scenario.value.id;
        const selectedSuiteId = this.newRowForm.controls.suite.value ? this.newRowForm.controls.suite.value.id : null;
        if (selectedSuiteId) {
          this.featureOptions = Object.values(this.artifactConnectionModel.features)
            .filter(feature => feature.scenarios.includes(selectedScenarioId) && feature.suites.includes(selectedSuiteId));
        } else {
          this.featureOptions = Object.values(this.artifactConnectionModel.features)
            .filter(feature => feature.scenarios.includes(selectedScenarioId));
        }
      } else if (this.newRowForm.controls.step.value != null) {
        const selectedStepId = this.newRowForm.controls.step.value.id;
        const selectedSuiteId = this.newRowForm.controls.suite.value ? this.newRowForm.controls.suite.value.id : null;
        if (selectedSuiteId) {
          this.featureOptions = Object.values(this.artifactConnectionModel.features)
            .filter(feature => feature.steps.includes(selectedStepId) && feature.suites.includes(selectedSuiteId));
        } else {
          this.featureOptions = Object.values(this.artifactConnectionModel.features)
            .filter(feature => feature.steps.includes(selectedStepId));
        }
      } else if (this.newRowForm.controls.suite.value != null) {
        const selectedSuiteId = this.newRowForm.controls.suite.value.id;
        this.featureOptions = Object.values(this.artifactConnectionModel.features)
            .filter(feature => feature.suites.includes(selectedSuiteId));
      }
    } else {
      this.featureOptions = Object.values(this.artifactConnectionModel.features)
    }
  }

  updateScenarioDropdownOptions() {
    if (this.artifactConnectionModel.artifactType !== ArtifactTypeEnum.Scenario) {
      if (this.newRowForm.controls.feature.value != null) {
        const selectedFeatureId = this.newRowForm.controls.feature.value.id;
        const selectedStepId = this.newRowForm.controls.step.value ? this.newRowForm.controls.step.value.id : null;
        if (selectedStepId) {
          this.scenarioOptions = Object.values(this.artifactConnectionModel.scenarios)
            .filter(scenario => scenario.features.includes(selectedFeatureId) && scenario.steps.includes(selectedStepId));
        } else {
          this.scenarioOptions = Object.values(this.artifactConnectionModel.scenarios)
            .filter(scenario => scenario.features.includes(selectedFeatureId));
        }
      } else if (this.newRowForm.controls.suite.value != null) {
        const selectedSuiteId = this.newRowForm.controls.suite.value.id;
        const selectedStepId = this.newRowForm.controls.step.value?this.newRowForm.controls.step.value.id:null;
        if (selectedStepId) {
          this.scenarioOptions = Object.values(this.artifactConnectionModel.scenarios)
            .filter(scenario => scenario.suites.includes(selectedSuiteId) && scenario.steps.includes(selectedStepId));
        } else {
          this.scenarioOptions = Object.values(this.artifactConnectionModel.scenarios)
            .filter(scenario => scenario.suites.includes(selectedSuiteId));
        }
      } else if (this.newRowForm.controls.step.value != null) {
        const selectedStepId = this.newRowForm.controls.step.value.id;
        this.scenarioOptions = Object.values(this.artifactConnectionModel.scenarios)
            .filter(scenario => scenario.steps.includes(selectedStepId));
      }
    } else {
      this.scenarioOptions = Object.values(this.artifactConnectionModel.scenarios)
    }
  }

  updateStepDropdownOptions() {
    if(this.artifactConnectionModel.artifactType !== ArtifactTypeEnum.Step) {
      if (this.newRowForm.controls.scenario.value != null) {
        const selectedScenarioId = this.newRowForm.controls.scenario.value.id;
        this.stepOptions = Object.values(this.artifactConnectionModel.steps).filter(step => step.scenarios.includes(selectedScenarioId));
      } else if (this.newRowForm.controls.feature.value != null) {
        const selectedFeatureId = this.newRowForm.controls.feature.value.id;
        this.stepOptions = Object.values(this.artifactConnectionModel.steps).filter(step => step.features.includes(selectedFeatureId));
      } else if (this.newRowForm.controls.suite.value != null) {
        const selectedSuiteId = this.newRowForm.controls.suite.value.id;
        this.stepOptions = Object.values(this.artifactConnectionModel.steps).filter(step => step.suites.includes(selectedSuiteId));
      }
    } else {
      this.stepOptions = Object.values(this.artifactConnectionModel.steps)
    }
  }

  onSuiteChange(suite: ArtifactModel) {
    this.populateDropdownOptions();
  }

  onFeatureChange(feature: ArtifactModel) {
    if (feature == null) {
      switch (this.artifactConnectionModel.artifactType) {
        case ArtifactTypeEnum.Suite:
          if(this.newRowForm.controls.scenario.value != null && !this.newRowForm.controls.suite.value.scenarios.includes(this.newRowForm.controls.scenario.value.id)) {
            this.newRowForm.get(ArtifactTypeEnum.Scenario).setValue(null);
          }
          if(this.newRowForm.controls.scenario.value == null && this.newRowForm.controls.step.value != null && !this.newRowForm.controls.suite.value.steps.includes(this.newRowForm.controls.step.value.id)) {
            this.newRowForm.get(ArtifactTypeEnum.Step).setValue(null);
          }
          break;
        case ArtifactTypeEnum.Scenario:
          if(this.newRowForm.controls.suite.value != null && !this.newRowForm.controls.scenario.value.suites.includes(this.newRowForm.controls.suite.value.id)) {
            this.newRowForm.get(ArtifactTypeEnum.Suite).setValue(null);
          }
          break;
        case ArtifactTypeEnum.Step:
          if (this.newRowForm.controls.suite.value != null) {
            if(this.newRowForm.controls.scenario.value != null && !this.newRowForm.controls.scenario.value.suites.includes(this.newRowForm.controls.suite.value.id)) {
              this.newRowForm.get(ArtifactTypeEnum.Suite).setValue(null);
            } else if(this.newRowForm.controls.scenario.value == null && !this.newRowForm.controls.step.value.suites.includes(this.newRowForm.controls.suite.value.id)) {
              this.newRowForm.get(ArtifactTypeEnum.Suite).setValue(null);
            }
          }
          break;
      }
    }
    this.populateDropdownOptions();
  }

  onScenarioChange(scenario: ArtifactModel) {
    if (scenario == null) {
      switch (this.artifactConnectionModel.artifactType) {
        case ArtifactTypeEnum.Suite:
          if (this.newRowForm.controls.step.value != null) {
            if(this.newRowForm.controls.feature.value != null && !this.newRowForm.controls.feature.value.steps.includes(this.newRowForm.controls.step.value.id)) {
              this.newRowForm.get(ArtifactTypeEnum.Step).setValue(null);
            } else if(this.newRowForm.controls.feature.value == null && !this.newRowForm.controls.suite.value.steps.includes(this.newRowForm.controls.step.value.id)) {
              this.newRowForm.get(ArtifactTypeEnum.Step).setValue(null);
            }
          }
          break;
        case ArtifactTypeEnum.Feature:
          if(this.newRowForm.controls.step.value != null && !this.newRowForm.controls.feature.value.steps.includes(this.newRowForm.controls.step.value.id)) {
            this.newRowForm.get(ArtifactTypeEnum.Step).setValue(null);
          }
          break;
        case ArtifactTypeEnum.Step:
          if(this.newRowForm.controls.feature.value != null && !this.newRowForm.controls.step.value.features.includes(this.newRowForm.controls.feature.value.id)) {
            this.newRowForm.get(ArtifactTypeEnum.Feature).setValue(null);
          }
          if(this.newRowForm.controls.feature.value == null && this.newRowForm.controls.suite.value != null && !this.newRowForm.controls.step.value.suites.includes(this.newRowForm.controls.suite.value.id)) {
            this.newRowForm.get(ArtifactTypeEnum.Suite).setValue(null);
          }
          break;
      }
    }
    this.populateDropdownOptions();
  }

  onStepChange(step: ArtifactModel) {
    this.populateDropdownOptions();
  }

  onCancelGithubCommitAdd() {
    this.isAddingGithubCommit = false;
    this.githubCommitForm.reset();
  }

  removeSelectedFile() {
    this.selectedProjectManagementFile = null;
  }

  areArraysEqual = (a: string[], b: string[]): boolean => {
          if (a.length !== b.length) return false;
          return a.every((val, index) => val === b[index]);
        };

  onSubmitGithubCommitAdd() {
    this.sharedService.loaderHide.emit(true);
    let projectManagementDataRows: string[][] = [];
    let projectManagementHeaderRow: string[] = [];

    let acceptedTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
    if (!acceptedTypes.includes(this.selectedProjectManagementFile.type)) {
      alert('Only EXCEL Files Allowed!');
      this.sharedService.loaderHide.emit(false);
      return;
    } else {
      const reader: FileReader = new FileReader();
      reader.readAsBinaryString(this.selectedProjectManagementFile);
      reader.onload = (e: any) => {
        let data = e.target.result;
        const workbook: XLSX.WorkBook = XLSX.read(data, { type: 'binary' });
        const worksheetName: string = workbook.SheetNames[0];
        const worksheet1: XLSX.WorkSheet = workbook.Sheets[worksheetName];
        const allRows: string[][] = XLSX.utils.sheet_to_json(worksheet1, { header: 1 });
        projectManagementHeaderRow = allRows[0] || [];
        projectManagementDataRows = allRows.slice(1) || [];
        this.codeLinkageMappingModel.project_id = this.projectId;
        this.codeLinkageMappingModel.project_management_fields = this.pmFieldNamesList;
        if (!this.areArraysEqual(projectManagementHeaderRow, this.pmFieldNamesList)) {
          this.sharedService.loaderHide.emit(false);
          alert("Mismatch in Project Management Fields in Input File");
        } else {
          let repoFullName = this.githubCommitForm.controls.repo.value;
          let repoBranchName = this.githubCommitForm.controls.branch.value;
          let repoCommitId = this.githubCommitForm.controls.commit.value.sha;
          this.codeLinkageService.createCodeLinkageByGitCommit(this.codeLinkageMappingModel, repoFullName, repoBranchName, repoCommitId, this.artifactAssociationsList, projectManagementDataRows, this.artifactId).subscribe(res => {
            this.isAddingGithubCommit = false;
            this.githubCommitForm.reset();
            this.isActiveCodeLinkageAvailable = true;
            this.sharedService.loaderHide.emit(false);
            this.isDataLoading = true;
            this.getLinkedCodeData();
          }, error => {
            this.sharedService.loaderHide.emit(false);
            alert("Error in Adding CodeLinkage");
          });
        }        
      };
    }
  }

  onCancelAdd() {
    this.isAddingNewRow = false;
    this.newRowForm.reset();
  }
  onSubmitAdd() {
    if (this.newRowForm.value.feature != null || this.newRowForm.value.scenario != null || this.newRowForm.value.step != null ) {
      Object.keys(this.newRowForm.controls).forEach(key => {
        const control = this.newRowForm.get(key);
        if (control.disabled) {
          control.enable();
        }
      });
      //Call the api here
      // this.codeLinkageService.addArtifactAssociationByArtifactId(this.artifactId,this.newRowForm.value)\
      // Call the API
      const formData = this.newRowForm.value; // Assuming this is your Angular form
      const dataToSend: ArtifactAssociationModel = {
        "_id": null,
        "deleted": 0,
        "created_time": new Date().getTime(),
        "suite_id": formData.suite ? formData.suite.id : null,
        "suite_name": formData.suite ? formData.suite.name : null,
        "feature_id": formData.feature ? formData.feature.id : null,
        "feature_name": formData.feature ? formData.feature.name : null,
        "scenario_id": formData.scenario ? formData.scenario.id : null,
        "scenario_name": formData.scenario ? formData.scenario.name : null,
        "step_id": formData.step ? formData.step.id : null,
        "step_name": formData.step ? formData.step.name : null,
        "modification": [],
      };
      // Now you can use this object when making the API call
      this.codeLinkageService.addArtifactAssociationByArtifactId(this.artifactId, dataToSend)
        .subscribe(
          res => {
            // Handle success response
            if(res.operationMessage == "java.lang.RuntimeException: Artifact Association Already Exists" ){
              // this.notifys.notify('success', 'Success', "Artifact Association already exists");
              this.notifys.notify('warning', 'Warning', "Artifact Association already exists");           
            }
            else if( res.operationMessage =="Error in Adding Association"){
              this.notifys.notify('error', 'Error', "Error in Adding Association");
            }
            else{
              this.notifys.notify('success', 'Success', "Sucessfully Created");
            }
            //console.log('Association added successfully:', res);
            this.getArtifactAssociationMappings();
          },
          err => {
            // Handle error response
            console.error('Error in adding association:', err);
            if (err.error && err.error.operationMessage) {
              console.error('Operation message:', err.error.operationMessage);
            }
          }
        );
      this.newRowForm.reset();
      this.isAddingNewRow = false;
    } else {
      // console.log(this.newRowForm.value.feature)
      console.log("Form is not valid");
    }
  }

  // End @Jishnu
  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  }

  getArtifactAssociationMappings() {
    this.codeLinkageService.getArtifactAssociationMappings(this.artifactType, this.artifactId).subscribe(res => {
      if (res["data"] == null && res["operationStatus"] == "ERROR") {
        this.isArtifactAssociationLoading = false;
      } else {
        this.artifactConnectionModel = res['data'];
        this.artifactAssociationsList = this.artifactConnectionModel.artifactAssociations;
        this.isArtifactAssociationLoading = false;
      }
      if (this.isActiveCodeLinkageAvailable) {
        this.isDataLoading = true
        this.getLinkedCodeData();
      }
    }, err => {
      this.isArtifactAssociationLoading = false;
      // alert(err.error['message']);
    });
  }

  openAssociationFormOverlay() {
    this.sharedService.loaderHide.emit(false);
    const formConfig = [
      { type: 'text', name: 'suiteName', label: 'Suite', required: this.artifactType === "suite", placeholder: "Select Suite", value: null },
      { type: 'text', name: 'featureName', label: 'Feature', required: this.artifactType === "feature", placeholder: "Select Feature", value: null },
      { type: 'text', name: 'scenarioName', label: 'Scenario', required: this.artifactType === "scenario", placeholder: "Select Scenario", value: null },
      { type: 'text', name: 'stepName', label: 'Step', required: this.artifactType === "step", placeholder: "Select Step", value: null }
    ];
    this.sharedService.openOverlayFormEvent.emit([true, formConfig, "Add Artifact Association", (form) => this.saveAssociation(form)]);
    this.sharedService.loaderHide.emit(false);
  }

  saveAssociation(form: FormGroup) {
    // call addArtifactAssociation() method here - method already exists
  }

  getCodeLinkageFields() {
    this.codeLinkageService.getCodeLinkageFieldsNamesByArtifactId(this.artifactType, this.artifactId).subscribe(res => {
      // console.log(res,"getcodelinkagefield")
      if (res['data'] != null) {
        this.pmFieldNamesList = res.data['pmFieldNames'];
        this.tdFieldNamesList = res.data['tdFieldNames'];
        this.codeLinkageFieldsNamesList = this.pmFieldNamesList.concat(this.tdFieldNamesList);
      } else if (res["data"] == null && res["operationStatus"] == "ERROR") {
        // alert("Error in Fetching Code Linkage Field Names");
      }
      this.isFieldsLoading = false;
    }, err => {
      this.isFieldsLoading = false;
      // alert(err.error['message']);
    });
  }

  getLinkedCodeData() {
    this.codeLinkageService.getLinkedCodeDataByArtifactId(this.artifactType, this.artifactId).subscribe(res => {
      if (res["data"] == null && res["operationStatus"] == "ERROR") {
        this.isDataLoading = false;
        // alert("Error in Fetching CodeLinkage data");
      } else {
        this.codeLinkedDataList = res['data'];
        this.isDataLoading = false;
      }
    }, err => {
      this.isDataLoading = false;
      // alert(err.error['message']);
    });
  }

  shouldShowDangerMessage(): boolean {
    if (this.codeLinkedDataList.length > 0) {
      return this.codeLinkedDataList.some(row => row[row.length - 2] === 'true');
    }
    return false;
  }

  deleteCodeLinkageMapping(row: string[], i) {
    this.isDataLoading = true;
    this.codeLinkageService.deleteCodeLinkageMappingById(row[row.length - 1]).subscribe(res => {
      if (res["data"] == null && res["operationStatus"] == "ERROR") {
        this.isDataLoading = false;
        // alert("Error in deleting Linked Data Mapping");
      } else {
        this.codeLinkedDataList.splice(i, 1);
        this.isDataLoading = false;
      }
    }, err => {
      this.isDataLoading = false;
      // alert("Error in deleting Linked Data Mapping");
    });
  }

  deleteArtifactAssociation(row: ArtifactAssociationModel, i) {
    this.isArtifactAssociationLoading = true;
    // if (this.isActiveCodeLinkageAvailable && row._id != undefined && row._id != null)
    if ( row._id != undefined && row._id != null) {
      this.codeLinkageService.deleteArtifactAssociationById(this.artifactId, row._id).subscribe(res => {
        if (res["data"] == null && res["operationStatus"] == "ERROR") {
          this.isArtifactAssociationLoading = false;
          // alert("Error in deleting Association");
        } else {
                this.artifactAssociationsList.splice(i, 1);
                this.isArtifactAssociationLoading = false;
                this.notifys.notify('warning', 'Deleted', "Deleted Sucessfully");
        }
      }, err => {
        this.isArtifactAssociationLoading = false;
        //  alert("Error in deleting Association");
      });
    } else {
      this.artifactAssociationsList.splice(i, 1);
      this.isArtifactAssociationLoading = false;
    }
  }

  addArtifactAssociation(row: ArtifactAssociationModel) {
    this.isArtifactAssociationLoading = true;
    const index = this.artifactAssociationsList.findIndex(association => (row.suite_id === association.suite_id && row.feature_id === association.feature_id
      && row.scenario_id === association.scenario_id && row.step_id === association.step_id));
    if (index !== -1) {
      if (this.isActiveCodeLinkageAvailable) {
        this.codeLinkageService.addArtifactAssociationByArtifactId(this.artifactId, row).subscribe(res => {
          if (res["data"] == null && res["operationStatus"] == "ERROR") {
            this.isArtifactAssociationLoading = false;
            // alert("Error in Adding Association");
          } else {
            this.artifactAssociationsList.push(res['data']);
            this.isArtifactAssociationLoading = false;
          }
        }, err => {
          this.isArtifactAssociationLoading = false;
          alert("Error in Adding Association");
        });
      } else {
        this.artifactAssociationsList.push(row);
        this.isArtifactAssociationLoading = false;
      }
    } else {
      this.isArtifactAssociationLoading = false;
      //show message like Association is already existing;
    }
  }

  addCodeLinkageUploadedRowsData(dataRows: string[][]) {
    let headerRow: string[] = dataRows[0] || [];
    dataRows = dataRows.slice(1) || [];
    this.codeLinkageMappingModel.project_id = this.projectId;
    this.codeLinkageMappingModel.project_management_fields = this.pmFieldNamesList;
    this.codeLinkageMappingModel.technical_details_fields = this.tdFieldNamesList;
    const expectedHeader: string[] = [...this.pmFieldNamesList, ...this.tdFieldNamesList];
    if (!this.areArraysEqual(headerRow, expectedHeader)) {
      this.sharedService.loaderHide.emit(false);
      alert("Mismatch in Project Management or Technical Fields in Input File");
    } else {
      this.codeLinkageService.createCodeLinkageByUploadedTemplate(this.codeLinkageMappingModel, this.pmFieldNamesList, this.tdFieldNamesList, this.artifactAssociationsList, dataRows, this.artifactId).subscribe(res => {
        this.isActiveCodeLinkageAvailable = true;
        this.sharedService.loaderHide.emit(false);
        this.isDataLoading = true;
        this.getLinkedCodeData();
      }, error => {
        this.sharedService.loaderHide.emit(false);
        alert("Error in Adding CodeLinkage");
      });
    }
  }

  onFileUpload(event: any) {
    this.sharedService.loaderHide.emit(true);
    //Need to show some loading in UI while data saving
    const target: DataTransfer = <DataTransfer>(event.target);
    let acceptedTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
    if (target.files.length == 1) {
      const file = target.files[0];
      if (!acceptedTypes.includes(file.type)) {
        alert('Only EXCEL Files Allowed!');
      } else {
        const reader: FileReader = new FileReader();
        reader.readAsBinaryString(target.files[0]);
        reader.onload = (e: any) => {
          let data = e.target.result;
          const workbook: XLSX.WorkBook = XLSX.read(data, { type: 'binary' });
          const worksheetName: string = workbook.SheetNames[0];
          const worksheet1: XLSX.WorkSheet = workbook.Sheets[worksheetName];
          this.isDataLoading = true;
          this.addCodeLinkageUploadedRowsData((XLSX.utils.sheet_to_json(worksheet1, { header: 1 })));
        };
      }
    }
    event.target.value = '';
  }

  onTemplateDownload() {
    if (this.codeLinkageFieldsNamesList.length == 0) {
      alert("Error in Fetching Organization Fields. Please Refresh the Page");
    } else {
      const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([this.codeLinkageFieldsNamesList, []]);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Template");
      XLSX.writeFile(workbook, this.artifactName.replace(/\s/g, "_") + "__code_linkage_template.xlsx");
    }
  }


}
